import { ExportByEmailModalTranslations } from "./export-by-email-modal-pt-br";

export const EXPORT_BY_EMAIL_MODAL_ES_ES: ExportByEmailModalTranslations = {
	title: "Exportar informe por correo electrónico",
	description:
		"El período seleccionado es mayor de {{days}} días. El informe se generará en segundo plano y se enviará al correo electrónico indicado.",
	emailLabel: "Correo electrónico",
	emailPlaceholder: "ejemplo@correo.com",
	confirmButton: "Confirmar envío",
	cancelButton: "Cancelar",
};
